<!--
 * @Author: hjp hjp@hjp.com
 * @Date: 2022-09-06 11:11:29
 * @LastEditors: hjp hjp@hjp.com
 * @LastEditTime: 2022-09-17 11:33:35
 * @FilePath: \yelink-ecm-developer-web\src\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div v-cloak id="app">
    <div
      v-if="!go && messages.length > 0 && messages[0].message"
      class="scroll-message"
      :style="{background: messages[0].level === 1 ? '#f2dede' : messages[0].level === 0 ? '#fcf8e3' : '#d9edf7'}"
    >
      <div class="message-container" :style="{color: messages[0].level === 1 ? '#a94442' : messages[0].level === 0 ? '#8a6d3b' : '#31708f'}">
        <span class="message-text">
          {{ messages[0].message }}
        </span>
        <span v-if="messages[0].level === 1 " class="link-to-profile" @click="gotoProfileAudit">点击查看</span>
      </div>
    </div>
    <router-view v-if="!go" />
    <DeveloperLogin v-else @toIndex="toIndex" @refreshNotice="refreshNotice" @gotoAuditExamine="gotoAuditExamine" />
  </div>
</template>

<script>
import DeveloperLogin from './components/DeveloperLogin/index.vue'
import { auditNotices } from '@/api/developer-organization'
export default {
  name: 'App',
  components: { DeveloperLogin },
  data() {
    return {
      go: false,
      messages: []
    }
  },
  mounted() {
    auditNotices().then(res => {
      this.messages = res
    })
    if (!localStorage.getItem('developerOrganizationId')) {
      // 开发者角色需选择开发者组织才能进入页面
      this.go = JSON.parse(localStorage.getItem('USER')).roles.includes('developer_tenant')
    }
  },
  methods: {
    gotoProfileAudit() {
      this.$router.push('/app-management/examine/developer-organization')
    },
    toIndex() {
      this.go = false
    },
    refreshNotice() {
      this.go = false
      this.messages = []
      auditNotices().then(res => {
        this.messages = res
      })
    },
    gotoAuditExamine() {
      this.go = false
      this.$nextTick(() => {
        this.$router.push('/app-management/examine/developer-organization', () => {
          window.location.reload()
        })
      })
    }
  }
}
</script>
<style scoped>
.scroll-message {
  position: absolute;
  top: 0.3rem;
  height: 50px;
  left: 25%;
  width: 49%;
  z-index: 1000;
}

.link-to-profile {
  color: #409EFF;
  text-decoration: underline;
}
.link-to-profile:hover {
  cursor: pointer;
  color: #66b1ff;
}

.message-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 1rem;
}

.message-text {
  margin-right: 10px;
}
</style>
